// Copyright (c) 2015, Daffy Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

daffy.provide("daffy.messages");

import './dialog';

daffy.messages.waiting = function(parent, msg) {
	return $(daffy.messages.get_waiting_message(msg))
		.appendTo(parent);
};

daffy.messages.get_waiting_message = function(msg) {
	return repl('<div class="msg-box" style="width: 63%; margin: 30px auto;">\
		<p class="text-center">%(msg)s</p></div>', { msg: msg });
}

daffy.throw = function(msg) {
	if(typeof msg==='string') {
		msg = {message: msg, title: __('Error')};
	}
	if(!msg.indicator) msg.indicator = 'red';
	daffy.msgprint(msg);
	throw new Error(msg.message);
}

daffy.confirm = function(message, ifyes, ifno) {
	var d = new daffy.ui.Dialog({
		title: __("Confirm"),
		fields: [
			{fieldtype:"HTML", options:`<p class="daffy-confirm-message">${message}</p>`}
		],
		primary_action_label: __("Yes"),
		primary_action: function() {
			if(ifyes) ifyes();
			d.hide();
		},
		secondary_action_label: __("No")
	});
	d.show();

	// flag, used to bind "okay" on enter
	d.confirm_dialog = true;

	// no if closed without primary action
	if(ifno) {
		d.onhide = function() {
			if(!d.primary_action_fulfilled) {
				ifno();
			}
		};
	}
	return d;
}

daffy.warn = function(title, message_html, proceed_action, primary_label, is_minimizable) {
	const d = new daffy.ui.Dialog({
		title: title,
		indicator: 'red',
		fields: [
			{
				fieldtype: 'HTML',
				fieldname: 'warning_message',
				options: `<div class="daffy-warning-message">${message_html}</div>`
			}
		],
		primary_action_label: primary_label,
		primary_action: () => {
			if (proceed_action) proceed_action();
			d.hide();
		},
		secondary_action_label: __("Cancel"),
		minimizable: is_minimizable
	});

	d.footer = $(`<div class="modal-footer"></div>`).insertAfter($(d.modal_body));

	d.get_close_btn().appendTo(d.footer);
	d.get_primary_btn().appendTo(d.footer);

	d.footer.find('.btn-primary').removeClass('btn-primary').addClass('btn-danger');

	d.show();
	return d;
};

daffy.prompt = function(fields, callback, title, primary_label) {
	if (typeof fields === "string") {
		fields = [{
			label: fields,
			fieldname: "value",
			fieldtype: "Data",
			reqd: 1
		}];
	}
	if(!$.isArray(fields)) fields = [fields];
	var d = new daffy.ui.Dialog({
		fields: fields,
		title: title || __("Enter Value"),
	});
	d.set_primary_action(primary_label || __("Submit"), function() {
		var values = d.get_values();
		if(!values) {
			return;
		}
		d.hide();
		callback(values);
	});
	d.show();
	return d;
}

daffy.msgprint = function(msg, title, is_minimizable) {
	if(!msg) return;

	if($.isPlainObject(msg)) {
		var data = msg;
	} else {
		// passed as JSON
		if(typeof msg==='string' && msg.substr(0,1)==='{') {
			var data = JSON.parse(msg);
		} else {
			var data = {'message': msg, 'title': title};
		}
	}

	if(!data.indicator) {
		data.indicator = 'blue';
	}

	if(data.message instanceof Array) {
		data.message.forEach(function(m) {
			daffy.msgprint(m);
		});
		return;
	}

	if(data.alert) {
		daffy.show_alert(data);
		return;
	}

	if(!daffy.msg_dialog) {
		daffy.msg_dialog = new daffy.ui.Dialog({
			title: __("Message"),
			onhide: function() {
				if(daffy.msg_dialog.custom_onhide) {
					daffy.msg_dialog.custom_onhide();
				}
				daffy.msg_dialog.msg_area.empty();
			},
			minimizable: data.is_minimizable || is_minimizable
		});

		// class "msgprint" is used in tests
		daffy.msg_dialog.msg_area = $('<div class="msgprint">')
			.appendTo(daffy.msg_dialog.body);

		daffy.msg_dialog.clear = function() {
			daffy.msg_dialog.msg_area.empty();
		}

		daffy.msg_dialog.indicator = daffy.msg_dialog.header.find('.indicator');
	}

	// setup and bind an action to the primary button
	if (data.primary_action) {
		if (data.primary_action.server_action && typeof data.primary_action.server_action === 'string') {
			data.primary_action.action = () => {
				daffy.call({
					method: data.primary_action.server_action,
					args: {
						args: data.primary_action.args
					}
				});
			}
		}

		if (data.primary_action.client_action && typeof data.primary_action.client_action === 'string') {
			let parts = data.primary_action.client_action.split('.');
			let obj = window;
			for (let part of parts) {
				obj = obj[part];
			}
			data.primary_action.action = () => {
				if (typeof obj === 'function') {
					obj(data.primary_action.args);
				}
			}
		}

		daffy.msg_dialog.set_primary_action(
			__(data.primary_action.label || "Done"),
			data.primary_action.action
		);
	} else {
		if (daffy.msg_dialog.has_primary_action) {
			daffy.msg_dialog.get_primary_btn().addClass('hide');
			daffy.msg_dialog.has_primary_action = false;
		}
	}

	if(data.message==null) {
		data.message = '';
	}

	if(data.message.search(/<br>|<p>|<li>/)==-1) {
		msg = daffy.utils.replace_newlines(data.message);
	}

	var msg_exists = false;
	if(data.clear) {
		daffy.msg_dialog.msg_area.empty();
	} else {
		msg_exists = daffy.msg_dialog.msg_area.html();
	}

	if(data.title || !msg_exists) {
		// set title only if it is explicitly given
		// and no existing title exists
		daffy.msg_dialog.set_title(data.title || __('Message'));
	}

	// show / hide indicator
	if(data.indicator) {
		daffy.msg_dialog.indicator.removeClass().addClass('indicator ' + data.indicator);
	} else {
		daffy.msg_dialog.indicator.removeClass().addClass('hidden');
	}

	// width
	if (data.wide) {
		// msgprint should be narrower than the usual dialog
		if (daffy.msg_dialog.wrapper.classList.contains('msgprint-dialog')) {
			daffy.msg_dialog.wrapper.classList.remove('msgprint-dialog');
		}
	} else {
		// msgprint should be narrower than the usual dialog
		daffy.msg_dialog.wrapper.classList.add('msgprint-dialog');
	}

	if (data.scroll) {
		// limit modal height and allow scrolling instead
		daffy.msg_dialog.body.classList.add('msgprint-scroll');
	} else {
		if (daffy.msg_dialog.body.classList.contains('msgprint-scroll')) {
			daffy.msg_dialog.body.classList.remove('msgprint-scroll');
		}
	}


	if(msg_exists) {
		daffy.msg_dialog.msg_area.append("<hr>");
	// append a <hr> if another msg already exists
	}

	daffy.msg_dialog.msg_area.append(data.message);

	// make msgprint always appear on top
	daffy.msg_dialog.$wrapper.css("z-index", 2000);
	daffy.msg_dialog.show();

	return daffy.msg_dialog;
}

window.msgprint = daffy.msgprint;

daffy.hide_msgprint = function(instant) {
	// clear msgprint
	if(daffy.msg_dialog && daffy.msg_dialog.msg_area) {
		daffy.msg_dialog.msg_area.empty();
	}
	if(daffy.msg_dialog && daffy.msg_dialog.$wrapper.is(":visible")) {
		if(instant) {
			daffy.msg_dialog.$wrapper.removeClass("fade");
		}
		daffy.msg_dialog.hide();
		if(instant) {
			daffy.msg_dialog.$wrapper.addClass("fade");
		}
	}
}

// update html in existing msgprint
daffy.update_msgprint = function(html) {
	if(!daffy.msg_dialog || (daffy.msg_dialog && !daffy.msg_dialog.$wrapper.is(":visible"))) {
		daffy.msgprint(html);
	} else {
		daffy.msg_dialog.msg_area.html(html);
	}
}

daffy.verify_password = function(callback) {
	daffy.prompt({
		fieldname: "password",
		label: __("Enter your password"),
		fieldtype: "Password",
		reqd: 1
	}, function(data) {
		daffy.call({
			method: "daffy.core.doctype.user.user.verify_password",
			args: {
				password: data.password
			},
			callback: function(r) {
				if(!r.exc) {
					callback();
				}
			}
		});
	}, __("Verify Password"), __("Verify"))
}

daffy.show_progress = function(title, count, total=100, description) {
	if(daffy.cur_progress && daffy.cur_progress.title === title && daffy.cur_progress.is_visible) {
		var dialog = daffy.cur_progress;
	} else {
		var dialog = new daffy.ui.Dialog({
			title: title,
		});
		dialog.progress = $(`<div>
			<div class="progress">
				<div class="progress-bar"></div>
			</div>
			<p class="description text-muted small"></p>
		</div`).appendTo(dialog.body);
		dialog.progress_bar = dialog.progress.css({"margin-top": "10px"})
			.find(".progress-bar");
		dialog.$wrapper.removeClass("fade");
		dialog.show();
		daffy.cur_progress = dialog;
	}
	if (description) {
		dialog.progress.find('.description').text(description);
	}
	dialog.percent = cint(flt(count) * 100 / total);
	dialog.progress_bar.css({"width": dialog.percent + "%" });
	return dialog;
}

daffy.hide_progress = function() {
	if(daffy.cur_progress) {
		daffy.cur_progress.hide();
		daffy.cur_progress = null;
	}
}

// Floating Message
daffy.show_alert = function(message, seconds=7, actions={}) {
	if(typeof message==='string') {
		message = {
			message: message
		};
	}
	if(!$('#dialog-container').length) {
		$('<div id="dialog-container"><div id="alert-container"></div></div>').appendTo('body');
	}

	let body_html;

	if (message.body) {
		body_html = message.body;
	}

	const div = $(`
		<div class="alert desk-alert">
			<div class="alert-message small"></div>
			<div class="alert-body" style="display: none"></div>
			<a class="close">&times;</a>
		</div>`);

	if(message.indicator) {
		div.find('.alert-message').append(`<span class="indicator ${message.indicator}"></span>`);
	}

	div.find('.alert-message').append(message.message);

	if (body_html) {
		div.find('.alert-body').show().html(body_html);
	}

	div.hide().appendTo("#alert-container").show()
		.css('transform', 'translateX(0)');

	div.find('.close, button').click(function() {
		div.remove();
		return false;
	});

	Object.keys(actions).map(key => {
		div.find(`[data-action=${key}]`).on('click', actions[key]);
	});

	div.delay(seconds * 1000).fadeOut(300);
	return div;
}

// Proxy for daffy.show_alert
Object.defineProperty(window, 'show_alert', {
	get: function() {
		console.warn('Please use `daffy.show_alert` instead of `show_alert`. It will be deprecated soon.');
		return daffy.show_alert;
	}
});
